import React from "react";
import { FaTwitter, FaInstagram, FaYoutube, FaTiktok} from "react-icons/fa";
import "./SocialMedia.css";

const SocialMediaSection = () => {
  const socialMediaLinks = [
    { id: 1, icon: <FaTiktok />, url: "https://www.tiktok.com/@crpnoctem", color: "#3b5998" },
    { id: 2, icon: <FaTwitter />, url: "https://x.com/crpnoctem", color: "#1DA1F2" },
    { id: 3, icon: <FaInstagram />, url: "https://www.instagram.com/crpnoctemm/", color: "#E1306C" },
    { id: 4, icon: <FaYoutube />, url:"https://www.youtube.com/@crpnoctemforever", color: "#FF0000" },
  ];

  return (
    <div className="social-media-bubbles">
      {socialMediaLinks.map((media) => (
        <a
          key={media.id}
          href={media.url}
          target="_blank"
          rel="noopener noreferrer"
          style={{ backgroundColor: "transparent" }}
          className="social-bubble"
        >
          {media.icon}
        </a>
      ))}
    </div>
  );
};

export default SocialMediaSection;
